var LabelingStrategyConfig = function () { return import('~/pages/labeling-strategy/labeling-strategy-config.vue'); };
var OutsourceSettle = function () { return import('~/pages/labeling-strategy/outsource-settle.vue'); };
var OutsourceCommission = function () { return import('~/pages/labeling-strategy/outsource-commission.vue'); };
var StrategyConfig = function () { return import("~/pages/labeling-strategy/strategy-config.vue"); };
export default [
    {
        path: '/labeling-strategy/labeling-strategy-config',
        name: 'labeling-strategy-config',
        component: LabelingStrategyConfig
    },
    {
        // 委外结算策略
        path: '/system-manage/outsource-settle',
        name: 'outsource-settle',
        component: OutsourceSettle
    },
    {
        // 委外佣金策略
        path: '/system-manage/outsource-commission',
        name: 'outsource-commission',
        component: OutsourceCommission
    },
    {
        title: "策略配置",
        path: '/system-manage/strategy-config',
        name: 'strategy-config',
        component: StrategyConfig
    }
];
